import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;
  background-color: ${brand.primary.teal.teal25};

  &[data-background='orange'] {
    background-color: ${brand.secondary.orange.orange75};
  }

  &[data-background='pear'] {
    background-color: ${brand.primary.pear.pear25};
  }

  &[data-background='yellow'] {
    background-color: ${brand.secondary.yellow.yellow50};
  }

  &[data-background='purple'] {
    background-color: ${brand.secondary.purple.purple25};
  }

  &[data-background='blue'] {
    background-color: ${brand.primary.blue.blue50};
  }

  &[data-background='teal'] {
    background-color: ${brand.primary.teal.teal25};
  }
  
  &[data-background='dark-blue'] {
    background-color: ${brand.accent.darkBlue.darkBlue25};
  }
  
  &[data-background='forrest-green'] {
    background-color: ${brand.accent.forrestGreen.forrestGreen25};
  }
  
  &[data-background='engage-sky'] {
    background-color: ${brand.engagePrimary.sky.sky25};
  }
  
  &[data-background='engage-teal'] {
    background-color: ${brand.engagePrimary.teal.teal25};
  }
  
  &[data-background='engage-lime'] {
    background-color: ${brand.engagePrimary.lime.lime25};
  }
  
  &[data-background='engage-pink'] {
    background-color: ${brand.engageSecondary.pink.pink25};
  }
  
  &[data-background='engage-lavender'] {
    background-color: ${brand.engageSecondary.lavender.lavender25};
  }
  
  &[data-background='engage-yellow'] {
    background-color: ${brand.engageSecondary.yellow.yellow25};
  }
  
  &[data-background='engage-tangerine'] {
    background-color: ${brand.engageSecondary.tangerine.tangerine25};
  }

  &[data-background='engage-purple'] {
    background-color: ${brand.engageSecondary.purple.purple25};
  }

  &[data-background='engage-green'] {
    background-color: ${brand.engagePrimary.green.green25};
  }

  &[data-background='engage-sea-green'] {
    background-color: ${brand.engagePrimary.seaGreen.seaGreen25};
  }

  &[data-background='engage-lilac'] {
    background-color: ${brand.engageSecondary.lilac.lilac25};
  }

  &[data-background='bronze'] {
    background-color: ${brand.awards.bronze.bronzeBg};
  }

  &[data-background='silver'] {
    background-color: ${brand.awards.silver.silverBg};
  }

  &[data-background='gold'] {
    background-color: ${brand.awards.gold.goldBg};
  }

  &[data-background='engage-cream'] {
    background-color: ${brand.engageNeutral.cream};
  }

  &[data-background='engage-dusk'] {
    background-color: ${brand.engageNeutral.dusk};
  }

  &[data-visible='false'] {
    display: none;
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
    padding-top: ${fluid(11, 13)};
    padding-bottom: ${fluid(11, 13)};
  }
`;
const ContentContainer = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 6;
  }
`;
const Carousel = styled.div `
  grid-column: 1 / span 12;
`;
const ItemArea = styled.div `
`;
const Link = styled.a `
  display: inline-flex;
  gap: 8px;
  color: ${brand.global.black};
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  

  span {
    ${fonts.gotham.medium};
    font-size: ${fluid(13, 16)};
    line-height: ${fluid(20, 23)};
    text-align: left;
  }
`;
const UspBarTrack = styled.div `
  --speed: 10s;
  --count: 4;
  --cardGap: ${fluid(16, 73)};
  --cardWidth: 400px;

  display: flex;
  animation: scrolling var(--speed) linear infinite;  

  @media ${until(Device.Desktop)} {
    gap: var(--cardGap);
  }

  @media ${from(Device.Desktop)} {
    justify-content: space-between;
    gap: 20px;
  }

  &[data-total='1'] {
    animation: none;
  }

  &[data-total='2'] {
    @media ${from(Device.TabletLarge)} {
      animation: none;
    }
  }

  &[data-total='3'] {
    @media ${from(Device.Desktop)} {
      animation: none;
    }
  }

  &[data-total='4'] {

    @media ${from(Device.DesktopLarge)} {
      animation: none;
    }
  }

  @keyframes scrolling {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(calc(var(--count) * (var(--cardGap) + var(--cardWidth)) * -1));
    }
  }
`;
const ItemHolder = styled.div `
  display: flex;
  gap: 8px;
  flex: 0 0 var(--cardWidth);  

  @media ${from(Device.DesktopLarge)} {
    flex: 1 1 auto;
  }

  div {
    ${contentStyles};
    ${fonts.gotham.medium};
    font-size: ${fluid(14, 16)};
    line-height: ${fluid(24, 26)};

    a {
      ${fonts.gotham.medium};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    p {
      ${fonts.gotham.medium};
      font-size: ${fluid(14, 16)};
      line-height: ${fluid(24, 26)};
    }
  }
`;
const ItemHolder2 = styled(ItemHolder) `

  [data-total='1'] & {
    display: none;
  }

  [data-total='2'] & {
    @media ${from(Device.TabletLarge)} {
      display: none;
    }
  }

  [data-total='3'] & {
    @media ${from(Device.Desktop)} {
      display: none;
    }
  }

  @media ${from(Device.DesktopLarge)} {
    display: none;
  }
`;
const ItemInner = styled.div `
  display: inline-flex;
  gap: 8px;

  svg {
    width: 20px;
    height: 20px;
    position: relative;
    top: 2px;
  }
`;
const Notification = styled.div `
  grid-column: 1 / span 12;
  
`;
const NotificationInner = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 26px;
  padding-right: 26px;

  @media ${until(Device.TabletLarge)} {
    flex-direction: column;
    align-items: start;
    padding-left: 0;
  }
`;
const NoticeMain = styled.div `
  display: flex;
  align-items: start;

  @media ${until(Device.TabletLarge)} {
    padding-left: 26px;
  }

  svg {
    width: ${fluid(18, 20)};
    height: ${fluid(18, 20)};
    margin-right: 8px;
    position: relative;
    top: ${fluid(2, 2)};
    flex: 0 0 ${fluid(18, 20)};

    @media ${until(Device.TabletLarge)} {
      position: absolute;
      left: 0;
      top: 4px;
    }
  }
`;
const NoticeContent = styled.div `
  ${fonts.gotham.regular};
  ${contentStyles};

  p {
    font-size: ${fluid(13, 16)};
    line-height: ${fluid(19, 23)};
  }
`;
const LinkButton = styled.a `
  ${fonts.gotham.medium};
  display: inline-flex;
  align-items: center;
  margin-left: ${fluid(10, 40)};
  gap: 4px;
  color: ${brand.global.black};
  font-size: ${fluid(13, 16)};
  line-height: ${fluid(19, 23)};

  @media ${until(Device.TabletLarge)} {
    padding-left: 26px;
    margin-left: 0;
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &:focus {
    outline: 2px solid ${brand.global.black};
  }

  svg {
    width: 12px;
    height: 12px;
    top: 0;
    margin-right: 0;

    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }
`;
const CloseBtn = styled.button `
  ${ButtonReset};
  ${transition('background-color')};

  position: absolute;
  top: ${fluid(9, 9)};
  right: ${fluid(6, 24)};
  border-radius: 10000000000px;
  width: ${fluid(20, 32)};
  height: ${fluid(20, 32)};

  &:hover {
    background-color: ${brand.global.black};

    svg {
      color: ${brand.global.white};
    }
  }

  &:focus {
    outline: 2px solid ${brand.global.black};
    background-color: ${brand.global.black};

    svg {
      color: ${brand.global.white};
    }
  }

  svg {
    ${transition('color')};
    width: ${fluid(20, 32)};
    height: ${fluid(20, 32)};
  }
`;
const UspBarStyles = {
    Container,
    ContentContainer,
    Carousel,
    ItemArea,
    Link,
    LinkButton,
    UspBarTrack,
    ItemHolder,
    ItemHolder2,
    ItemInner,
    Notification,
    NotificationInner,
    NoticeMain,
    NoticeContent,
    CloseBtn,
};
export default UspBarStyles;
